import { useCallback, useEffect, useMemo, useState } from "react";
import { useDispatch } from "react-redux";

import { fetchPageObject, fetchShakespeareStatus, getCaseId } from "../Utils/helper";
import Sidebar from "../Components/Sidebars/main";
import NavBar from "../Components/Navbars/main";
import ActionBarComponent from "../Components/common/ActionBarComponent";
import NotesSectionDashboard from "../Components/NotesSectionDashboard/main";
import Footer from "../Components/common/footer";
import ResponsiveTabTwoItems from "../Components/DefendantPage/DefandantMain/components/ResponsiveTabTwoItems";
import { api_without_cancellation } from "../api/api";
import AccountsTable from "../Components/AccountsDashboard/AccountsTable";
import { CheckRequestModalProvider } from "../Components/AccountsDashboard/CheckRequestModalContext";
import { AlertCheckNotRequestedProvider } from "../Components/AccountsDashboard/AlertCheckNotRequestedModalContext";
import { AccountsManagementProvider } from "../Components/AccountsDashboard/AccountsManagementContext";
import { UpdateTriggerProvider } from "../Components/AccountsDashboard/TriggerUpdateContext";
import AlertCheckNotRequested from "../Components/AccountsDashboard/AlertCheckNotRequestedModal";
import CheckRequestModal from "../Components/AccountsDashboard/CheckRequestModal";
import AccountsManagementModal from "../Components/AccountsDashboard/AccountsManagementModal";

const AccountingNewPage = () => {
  const [sideBarCollapsed, setSideBarCollapsed] = useState(null);
  const dispatch = useDispatch();
  const caseId = getCaseId();
  const [pageObject, setPageObject] = useState(null);

  useEffect(() => {
    if (caseId && !pageObject) {
      fetchPageObject(caseId, 37).then((data) => {
        setPageObject(data);
      });
    }
  }, [caseId, pageObject]);

  useEffect(() => {
    const getUserPreferencesFromStorage = () => {
      const preferences = localStorage.getItem("userPreferences");
      const preferencesObj = preferences ? JSON.parse(preferences) : null;
      setSideBarCollapsed(preferencesObj?.SidebarView);
    };
    getUserPreferencesFromStorage();
  }, []);

  const [currentPage, setCurrentPage] = useState("all");
  const [viewType, setViewType] = useState("checks");
  const handlePageChange = useCallback((pageType) => {
    setCurrentPage(pageType);
  }, []);
  //   Accounts Data
  const [accountsData, setAccountsData] = useState([]);

  const fetchAccountsData = async (key = currentPage) => {
    try {
      const response = await api_without_cancellation.get(
        `/api/accounting-page/checks/?case_id=${getCaseId()}&query_type=${key}`
      );
      if (response.status === 200) {
        setAccountsData(response.data.data);
      }
    } catch (error) {
      console.error(error);
    }
  };

  useEffect(() => {
    fetchShakespeareStatus(getCaseId(), 37, dispatch);
  }, [dispatch]);

  useEffect(() => {
    fetchAccountsData();
  }, [currentPage]);

  const mainTabs = useMemo(() => {
    const tabs = [];

    if (viewType === "trust_led") {
      tabs.push({
        id: "openWithBalance",
        label: "Open With Balance",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handlePageChange("openWithBalance"),
        leftHand: false,
      });
      tabs.push({
        id: "closedWithBalance",
        label: "Closed With Balance",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handlePageChange("closedWithBalance"),
        leftHand: false,
      });
      tabs.push({
        id: "zeroBalance",
        label: "Zero Balance",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handlePageChange("zeroBalance"),
        leftHand: false,
      });
    } else {
      tabs.push({
        id: "all",
        label: "All",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handlePageChange("all"),
        leftHand: false,
      });

      tabs.push({
        id: "requested",
        label: "Check Requests",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handlePageChange("requested"),
        leftHand: false,
      });

      tabs.push({
        id: "paid",
        label: "Paid",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handlePageChange("paid"),
        leftHand: false,
      });

      tabs.push({
        id: "cleared",
        label: "Cleared",
        className: "tab-trapezium-cycles-corners",
        background: "var(--primary-5)",
        activeColor: "white",
        onClick: () => handlePageChange("cleared"),
        leftHand: false,
      });
    }
    //

    return tabs;
  }, [handlePageChange, viewType]);

  const viewTabs = useMemo(() => {
    const tabs = [];

    tabs.push(
      {
        id: "checks",
        label: "Checks",
        className:
          viewType === "checks"
            ? "active tab-trapezium-cycles-corners z-2"
            : "tab-trapezium-cycles-corners",
        background: viewType === "checks" ? "var(--primary) !important" : "var(--primary-60)",
        activeColor: "white",
        onClick: () => {
          setViewType("checks");
          setCurrentPage("all");
        },
        leftHand: false,
        //   span: (
        //     <span className="fw-bold text-gold ">
        //       <img src={DatesIcon} width="25" alt="Summary" />
        //     </span>
        //   ),
      },
      {
        id: "trust_led",
        label: "Trust Ledger",
        className:
          viewType === "trust_led"
            ? "active tab-trapezium-cycles-corners z-2"
            : "tab-trapezium-cycles-corners",
        background: viewType === "trust_led" ? "var(--primary) !important" : "var(--primary-60)",
        activeColor: "white",
        onClick: () => {
          setViewType("trust_led");
          setCurrentPage("openWithBalance");
        },
        leftHand: false,
        //   span: (
        //     <span className="fw-bold text-gold">
        //       <img src={SimpleIcon} width="25" alt="Dates" />
        //     </span>
        //   ),
      }
    );

    return tabs;
  }, [viewType]);

  const [selectedAccount, setSelectedAccount] = useState({});
  const [bankData, setBankData] = useState([]);
  const [countMap, setCountMap] = useState({});

  const fetchAccounts = async () => {
    try {
      // const response = await api_without_cancellation.get(
      //   origin +
      //   `/api/documents/get-courtforms/?client_id=${getClientId()}&case_id=${getCaseId()}`
      // );
      const response = await api_without_cancellation.get(
        `/api/accounting-page/select-bank-accounts/?case_id=${getCaseId()}`
      );
      if (response.status === 200) {
        setBankData(response.data.data);
        setSelectedAccount(response.data.selected_account);
        setCountMap(response.data.account_records_count_map);
      }
    } catch (error) {
      console.error(error);
    }
  };

  const updateAccount = async (account) => {
    try {
      setSelectedAccount(account);
      const payload = {
        case_id: getCaseId(),
        bank_account: account?.id,
      };
      // const response = await api_without_cancellation.get(
      //   origin +
      //   `/api/documents/get-courtforms/?client_id=${getClientId()}&case_id=${getCaseId()}`
      // );
      const response = await api_without_cancellation.post(
        "/api/accounting-page/select-bank-accounts/",
        payload
      );
      if (response.status === 200) {
        fetchAccountsData();
      }
    } catch (error) {
      console.error(error);
    }
  };
  useEffect(() => {
    fetchAccounts();
  }, []);

  return (
    <>
      <CheckRequestModalProvider>
        <AlertCheckNotRequestedProvider>
          <AccountsManagementProvider>
            <UpdateTriggerProvider>
              <div className={`page-wrapper ${sideBarCollapsed ? "force-collapsed" : ""}`}>
                <Sidebar />
                <div className="page-container overflow-hidden">
                  <NavBar flaggedPageName={"37"} />
                  <ActionBarComponent
                    src={pageObject?.page_icon}
                    page_name={pageObject?.name}
                    pageObj={pageObject}
                    isChecklist={pageObject?.PageChklst || false}
                  />
                  <div className="TreatmentPage-main-container invisible-scrollbar">
                    <ResponsiveTabTwoItems
                      HandlePage={currentPage}
                      tabsData={mainTabs}
                      addTab={viewTabs}
                      handlePageChange={handlePageChange}
                    />
                    <div
                      style={{
                        width: "100%",
                        justifyContent: "flex-start",
                        background: "var(--primary)",
                        height: "25px",
                        marginBottom: "5px",
                      }}
                    >
                      <div
                        style={{
                          height: "25px",
                          display: "flex",
                          justifyContent: "center",
                          alignItems: "center",
                          transform: "none",
                          fontStyle: "normal",
                          color: "white",
                        }}
                      >
                        <div />
                        {bankData.length > 0 ? (
                          <>
                            {bankData.map((account) => (
                              <label
                                key={account.id} // Adding a unique key for each element
                                style={{
                                  margin: "0 50px 0 0",
                                  display: "flex",
                                  justifyContent: "center",
                                  alignItems: "center",
                                }}
                              >
                                <input
                                  onClick={() => updateAccount(account)}
                                  checked={selectedAccount.id === account.id}
                                  style={{ cursor: "default", marginRight: "5px" }}
                                  type="radio"
                                  name="account"
                                />
                                {account?.account_name} - *{account?.account_number?.slice(-4)} (
                                {countMap[account?.id]})
                              </label>
                            ))}
                          </>
                        ) : null}
                      </div>
                    </div>

                    <AccountsTable costs={accountsData} fetchAccountsData={fetchAccountsData} />
                    <NotesSectionDashboard pageName={"Experts"} />
                  </div>
                </div>
              </div>

              <Footer />
              {/* Modals */}
              <CheckRequestModal />
              <AlertCheckNotRequested />
              <AccountsManagementModal />
            </UpdateTriggerProvider>
          </AccountsManagementProvider>
        </AlertCheckNotRequestedProvider>
      </CheckRequestModalProvider>
    </>
  );
};

export default AccountingNewPage;
